import {
    API_BASE_URL,
    getAccessToken,
    getCookie,
    handleResponse,
    apiGet,
    apiPost,
} from "../../../api/client";
import { ApiConfig } from "../../../api/config";

function normalizeTreatmentId(treatmentId) {
    const numericTreatmentId = Number.parseInt(treatmentId, 10);
    if (!Number.isFinite(numericTreatmentId)) {
        throw new Error("รหัสการรักษาไม่ถูกต้อง");
    }

    return numericTreatmentId;
}

function buildClinicalNotePath(treatmentId) {
    return `${ApiConfig.CLINIC_BASE}/treatments/${normalizeTreatmentId(treatmentId)}/clinical-note/`;
}

function createFormDataRequestOptions(formData) {
    const token = getAccessToken();
    const csrftoken = getCookie("csrftoken");
    const headers = {};

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    if (csrftoken) {
        headers["X-CSRFToken"] = csrftoken;
    }

    return {
        method: "POST",
        headers,
        credentials: "include",
        body: formData,
    };
}

export async function uploadAudioChunk({
    treatmentId,
    audioFile,
    chunkIndex,
    uploadedDurationSeconds,
    isLastChunk,
}) {
    const formData = new FormData();
    formData.append("audio_file", audioFile);
    formData.append("chunk_index", String(chunkIndex));
    formData.append("uploaded_duration_seconds", String(uploadedDurationSeconds ?? 0));
    formData.append("is_last_chunk", isLastChunk ? "True" : "False");

    const res = await fetch(
        `${API_BASE_URL}${buildClinicalNotePath(treatmentId)}audio-chunk/`,
        createFormDataRequestOptions(formData)
    );

    return handleResponse(res);
}

export async function fetchClinicalNote(treatmentId) {
    return apiGet(buildClinicalNotePath(treatmentId));
}

export async function resetClinicalNoteAudio(treatmentId) {
    return apiPost(`${buildClinicalNotePath(treatmentId)}audio/reset/`);
}

export async function summarizeClinicalNote(treatmentId, payload = {}) {
    return apiPost(`${buildClinicalNotePath(treatmentId)}summarize/`, payload);
}
